import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'calampqaus',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/calampprodus/light-logo.svg',
    darkLogo: 'assets/calampprodus/dark-logo.svg',
    alt: 'Calampqaus',
    width: '100px',
    height: '30px',
    loginPageWidth: '120px',
    loginPageHeight: '36px',
  },
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
